module.exports = __webpack_public_path__ + "static/media/philbox-img01.64570c20.jpg";